import "./qualification.scss";
type QualificationPageProps = {};

const QualificationPage = (props: QualificationPageProps) => {
  return (
    <>
      <div className="qualification page">
        <div className="qualification__header page__header">
          <h1 className="qualification__header__title page__header__title">
            КВАЛИФИКАЦИЯ
          </h1>
        </div>
        <div className="qualification__body">
          <h1 className="qualification__body__title">
            Професионални квалификации за периода 2023 г. – 2026 г.
          </h1>
          <p className="qualification__body__content">
            <strong>Удостоверение № С7 - 0000005803 /26-03-2023г. </strong>-
            ,,Най-новите информационни технологии в процеса на обучение” –
            Просвета –София АД - 1 кредит
          </p>
          <p className="qualification__body__content">
            <strong>Сертификат № ABC- 00066 /23.06.2023г. </strong>-“Общ
            регламент за защита на данните в ЕС.Детска престъпност,
            киберсигурност и опасности за децата в мрежата.Практически насоки” –
            АВС Учебна академия гр. Пловдив – 2 кредита
          </p>
          <p className="qualification__body__content">
            <strong>Удостоверение № ОУД23-1270/04.12.2023г.</strong>-“Иновативни
            подходи при преподаване в електронна среда”- Университет „Проф.д-р
            Асен Златаров“ – Бургас – 2 кредита
          </p>
          <p className="qualification__body__content">
            <strong>Удостоверение Рег№ А- 000227 /03.06.2024г.</strong>
            -“Семейството и неговата роля, като първи сътрудник за изграждане на
            толерантност и съпричастност.”- Академия Веда-1 кредит
          </p>
          <p className="qualification__body__content">
            <strong>Удостоверение Рег№ А- 000193 /04.07.2025г.</strong>
            -“Психологически комфорт на работното място. Методи за ефективно
            взаимодействие и управление на конфликти” -Академия Веда - 2
            квалификационни кредита
          </p>
          <p className="qualification__body__content">
            <strong>Удостоверение Рег№ А- 000913 /13.07.2026г.</strong>
            -“Превенция на противообществените прояви и употреба на психоактивни
            вещества в училищна среда и сътрудничество с родители” -Академия
            Веда - 1 квалификационен кредит
          </p>
          <p className="qualification__body__content">
            <strong>29.11.25г. гр. Банско</strong>
            -“Сертификат за участие в обучение, насочено към развитие на
            емоционална интелигентност, ефективна комуникация и създаване на
            позитивна и приобщаваща среда” - „Училището като общност – споделени
            отговорности и доверие„
          </p>
          <p className="qualification__body__content">
            <strong>Удостоверение № 183729/09.03.2026г.</strong>
            -“Атестиране на педагогическите специалисти” - РААБЕ България – гр.
            София – 1 кредит
          </p>
        </div>
      </div>
    </>
  );
};

export default QualificationPage;
